<div
  *ngIf="itemList"
  [class.active]="isOpenSelect"
  [class.error]="!!errorText"
  [class.disabled]="isDisableSelect"
  class="input-line select">
  <p class="input-line__name">{{title}}</p>
  <label
    (click)="openSelect()"
    class="label">
    <input
      [formControl]="selectFormControl"
      (blur)="onTouchedFn($event)"
      readonly
      class="input-line__input"
      type="text">
  </label>
  <ul
    *ngIf="itemList.length > 0"
    [class.top]="positionList === 'top'"
    [class.bottom]="positionList === 'bottom'"
    [class.small]="isSmall"
    class="select__list">
    <li
      *ngFor="let item of itemList"
      (click)="setSelectedItem(item)"
      class="select__list-item">
      {{item.description}}
    </li>
  </ul>
  <div
    class="input-line__error">
    {{errorText | translate}}
  </div>
</div>
